import { render, staticRenderFns } from "./foreign_address_modal.vue?vue&type=template&id=5a721f7c&scoped=true"
import script from "./foreign_address_modal.vue?vue&type=script&lang=js"
export * from "./foreign_address_modal.vue?vue&type=script&lang=js"
import style0 from "./foreign_address_modal.vue?vue&type=style&index=0&id=5a721f7c&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/user/addressAdd.less?vue&type=style&index=1&id=5a721f7c&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a721f7c",
  null
  
)

export default component.exports